import React, { Component } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import i18n from "../../../i18n";



const EMOTIONS = [
  { key: 'love', label: i18n.t('Like'), icon: '/img/em_blove.png' },
  { key: 'inspiration', label: i18n.t('Inspiring'), icon: '/img/em_inspiring.png' },
  { key: 'tristesse', label: i18n.t('Sad'), icon: '/img/em_bface.png' },
  { key: 'colere', label: i18n.t('Angry'), icon: '/img/em_angry.png' },
  { key: 'joie', label: i18n.t('Happy'), icon: '/img/em_bjoy.png' },
  //{ key: 'curiosite', label: 'Curiosité', icon: '/img/em_inspiration.png' },
  { key: 'reflexion', label: i18n.t('Thoughtful'), icon: '/img/em_bthinking.png' },
  { key: 'connexion', label: i18n.t('Connected'), icon: '/img/em_connexion.png' }
];

export default class EmotionReactionsDisable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReactions: false,
      selectedEmotion: {"key":"love","label":"J'aime","icon":"/img/em_blove.png"}, //null,
      reactionCounts: {
        inspiration: 0,
        tristesse: 0,
        colere: 0,
        joie: 0,
        curiosite: 0,
        reflexion: 0,
        connexion: 0
      }
    };
  }

  handleEmotionClick = (emotion) => {
    const { selectedEmotion, reactionCounts } = this.state;
    const newCounts = { ...reactionCounts };

    if (selectedEmotion?.key === emotion.key) {
      // toggle off
      newCounts[emotion.key] = Math.max(0, newCounts[emotion.key] - 1);
      this.setState({ selectedEmotion: null, showReactions: false, reactionCounts: newCounts });
    } else {
      // toggle on
      if (selectedEmotion) {
        newCounts[selectedEmotion.key] = Math.max(0, newCounts[selectedEmotion.key] - 1);
      }
      newCounts[emotion.key] = (newCounts[emotion.key] || 0) + 1;
      //alert(JSON.stringify(emotion))
      this.setState({ selectedEmotion: emotion, showReactions: false, reactionCounts: newCounts });
    }

    if (this.props.onReact) {
      this.props.onReact(emotion);
    }
  };

  render() {
    const { showReactions, selectedEmotion, reactionCounts } = this.state;

    return (
      <div
        className="reaction-container"
      >
        <button className={'react-button'} style={{color: '#555', opacity: 0.6}}>
           <>
            <img src={'/img/em_react.png'} alt={i18n.t('React')} className="button-icon" />
              {i18n.t('React')}
            </>
        </button>
      </div>
    );
  }
}
